module.exports = __webpack_public_path__ + "img/powered_by_horizontal_b.0c74593e.png";